import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

// Components
import Slider from 'react-slick';
import { SliderPagination } from '../SliderPagination/SliderPagination';
import { SliderPaginationListItem } from '../SliderPagination/SliderPaginationListItem';
import { ImageSliderItem } from '../ImageSliderItem/ImageSliderItem';

// Styles
import './image-slider.scss';

export const ImageSlider = ({ images }) => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const imageSlider = useRef();

  const nextSlide = () => {
    imageSlider.current.slickNext();
  }
  const previousSlide = () => {
    imageSlider.current.slickPrev();
  }

  const goToSlide = (id) => {
    imageSlider.current.slickGoTo(id);
  }

  const responsive = [
    {
      breakpoint: 749,
      settings: {
        autoplay: true
      }
    },
    {
      breakpoint: 750,
      settings: {
        autoplay: false
      }
    }
  ]

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    responsive,
    swipeToSlide: true,
    touchMove: true,
    appendDots: dots => (
      <SliderPagination
        dots={dots}
        nextSlide={nextSlide}
        previousSlide={previousSlide} />
      
    ),
    customPaging: i => (
      <SliderPaginationListItem
        index={i}
        goToSlide={goToSlide}
        currentSlide={currentSlide} />
    ),
    afterChange: index => setCurrentSlide(index + 1)
  };

  return (
    <div className="slider-container">
      <div className="image-slider">
        <Slider {...settings} ref={imageSlider}>
          {images.map(({ id, fluid }) =>
            <ImageSliderItem key={id} fluid={fluid} />
          )}
        </Slider>
      </div>
    </div>
  );
}

ImageSlider.propTypes = {
  images: PropTypes.array
};
